module.exports = __webpack_public_path__ + "static/media/Kuwait.b1850d25.png";